export default [{"tag":"path","att":{"d":"m13 7.83 5.59 5.59L20 12l-8-8-8 8 1.41 1.41L11 7.83V20h9v-2h-7V7.83z"}}]